import styled from 'styled-components';
import Input from 'components/Input';

export const InputTag = styled(Input).attrs({  
  id: "tagSimple",
  stateName: "tagSimple",
  name: "Tags",
  className: "w-100",
  type: "text",
  placeholder: `Digite a tag e pressione ENTER ou ','`
})`
  border: none;
  min-width: 180px;

  &:focus {
    border: none;
  }
`;
